
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { delObjEmptyKey, parseTime } from '@/utils'
import {
  getGcashAccountList,
  delGcashAccount,
  setConnectivityTest,
  setInviteLogin,
} from '@/api/gcash/account'
import { getAllGcash } from '@/api/gcash/groups'
import { AppModule } from '@/store/modules/app'
import addAccount from './gcashComponents/add.vue'
import editAccount from './gcashComponents/edit.vue'
import collectionLog from './gcashComponents/collectionLog.vue'
import paymentLog from './gcashComponents/paymentLog.vue'
import smsLog from './gcashComponents/smsLog.vue'
import actionLog from './gcashComponents/actionLog.vue'
import allDetele from './gcashComponents/allDetele.vue'
import allBatchBulk from './gcashComponents/allBatchBulk.vue'
import editGroupsList from './gcashComponents/editGroupsList.vue'
import onePay from './gcashComponents/onePay.vue'
import group from './gcashComponents/group.vue'
import groupManage from './gcashComponents/groupManage.vue'
import bulkLogin from './gcashComponents/bulkLogin.vue'
import upExcel from './gcashComponents/upBatchExcel.vue'
import { filter } from 'vue/types/umd'

@Component({
  name: 'gcashAccount',
  components: {
    addAccount,
    editAccount,
    collectionLog,
    paymentLog,
    smsLog,
    actionLog,
    allDetele,
    allBatchBulk,
    editGroupsList,
    onePay,
    group,
    groupManage,
    bulkLogin,
    upExcel,
  },
  filters: {
    parseTime(date) {
      return parseTime(date, '{y}-{m}-{d} {h}:{i}:{s}')
    },
  },
})
export default class extends Vue {
  get language() {
    return AppModule.language
  }
  private queryForm: any = {
    search: '',
    onlie_status: null,
    account_status: null,
    sms_id: '',
    account_name: '',
  }
  private listLoading: boolean = false
  private gcashList: any[] = []
  private selectList: any[] = []
  private orderStatusList: any = []
  private total = 0
  private activeName: any = '1'

  private async setStatus(row: any) {
    // 保存原来的状态
    const status = row.account_status === 0 ? 1 : 0
    let data: any = {}
    if (row.account_status === 0) {
      data = {
        action: 'delete_active',
        data: {
          msisdn: row.phone_number,
        },
      }
    }
    if (row.account_status === 1) {
      data = {
        action: 'active',
        data: {
          msisdn: row.phone_number,
        },
      }
    }
    try {
      await setConnectivityTest(data).then((res: any) => {
        this.$message({
          message: 'Save successful!',
          type: 'success',
        })
        this.hadleGetFilesListApi()
      })
    } catch (e) {
      row.account_status = status
    }
  }

  // 批量删除
  private allDeteleVisible: boolean = false
  private allDetele() {
    this.allDeteleVisible = true
  }
  private closeAllDetele() {
    this.allDeteleVisible = false
    this.hadleGetFilesListApi()
  }

  // 批量转账
  private allBatchVisible: boolean = false
  private allBatchBulk() {
    this.allBatchVisible = true
  }
  private closeAllBatchBulk() {
    this.allBatchVisible = false
    this.hadleGetFilesListApi()
  }

  // 余额排序
  private sortChange(column, prop, order) {
    if (!column.order) {
      let el: any = this.$refs.table
      el.sort('data', 'ascending')
    }
    if (column.prop === 'balance') {
      column.order === 'ascending'
        ? (this.queryForm.ordering = 'balance')
        : column.order === 'descending'
        ? (this.queryForm.ordering = '-balance')
        : (this.queryForm.ordering = null)
    }
    this.hadleGetFilesListApi()
    // 输出的结果 [object Object]---name---ascending
  }

  // 分组管理
  private groupListVisible: boolean = false
  private getGroupsList() {
    this.groupListVisible = true
  }
  private closeGroupList() {
    this.groupListVisible = false
    this.hadleGetFilesListApi()
  }

  private groupVisible: boolean = false
  private openGroup() {
    this.groupVisible = true
    // if (this.selectList.length === 0) {
    this.selectList = this.gcashList
    // }
  }
  private closeGroup() {
    this.groupVisible = false
    this.hadleGetFilesListApi()
  }

  private async getbBalance(id) {
    try {
      const data: any = {
        action: 'refresh_balance',
        data: {
          msisdn: id,
        },
      }
      delObjEmptyKey(data)
      await setInviteLogin(data).then((res: any) => {
        this.$message({
          message: 'Successfully Queried Balance!',
          type: 'success',
        })
        this.hadleGetFilesListApi()
      })
    } catch (error) {
      console.log()
    }
  }

  private rules: any = {
    otp: [{ required: true, message: 'Please enter OTP', trigger: 'blur' }],
  }

  private infoVisble: boolean = false
  private rowInfo: any = {}
  private openInfo(row: any) {
    this.rowInfo = row
    this.infoVisble = true
  }
  private closeRow() {
    this.infoVisble = false
    this.activeName = '1'
    this.hadleGetFilesListApi()
  }

  // 单笔代付
  private onePayVisble: boolean = false
  private payInfo: any = {}
  private openOnePay(row: any) {
    this.payInfo = row
    this.onePayVisble = true
  }
  private closeOnePay() {
    this.onePayVisble = false
    this.hadleGetFilesListApi()
  }

  public flag: boolean = false
  // 按钮只触发一次
  public flagStr() {
    setTimeout(() => {
      this.flag = false
      this.loginFlag = false
    }, 1000)
  }
  // 批量登录
  private bulkLoginVisble: boolean = false
  private loginLoading: boolean = false
  private loginFlag: boolean = false
  private async openBulkLogin() {
    // this.bulkLoginVisble = true
    try {
      this.loginLoading = true
      this.loginFlag = true
      let data: any = {
        action: 'batch_login',
      }
      await setInviteLogin(data).then((res: any) => {
        // window.open(res.url)
        // this.copy(res.url)
        this.loginLoading = false
        this.$message.success('Successful operation!')
        this.flagStr()
        this.hadleGetFilesListApi()
      })
    } catch (error) {
      this.loginLoading = false
      this.flagStr()
    }
  }
  private closeBulkLogin() {
    this.bulkLoginVisble = false
    this.hadleGetFilesListApi()
    this.flagStr()
  }

  // 批量上传账户
  private upExcelVisble: boolean = false
  private upExcelName: string = '1'
  private openUpExcel() {
    this.upExcelVisble = true
  }
  private closeUpExcel() {
    this.upExcelVisble = false
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private reset() {
    this.queryForm = {
      account_no: '',
      status: null,
      state: null,
      sms_id: '',
      account_name: '',
    }
    this.currentPage = 1
    this.$nextTick(() => {
      this.hadleGetFilesListApi()
    })
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      const data: any = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage,
      }
      delObjEmptyKey(data)
      await getGcashAccountList(data).then((res: any) => {
        this.gcashList = res.results
        this.total = res.count
        this.listLoading = false
        this.selectList = res.results
        this.activeList = res.results.filter((item) => {
          return item.onlie_status === 1
        })
        this.batchLogin = res.results.filter((item) => {
          return item.onlie_status === 0
        })
      })
    } catch (error) {
      this.gcashList = []
      this.listLoading = false
    }
  }

  private delInfo(id: number) {
    if (this.language === 'en') {
      this.$confirm('Are you sure to delete it?', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning',
        callback: (action) => {
          const data: any = {
            id: id,
          }
          if (action === 'confirm') {
            delGcashAccount(data).then(() => {
              this.$message({
                type: 'success',
                message: 'Delete successful!',
              })
              this.hadleGetFilesListApi()
            })
          }
        },
      })
    }
    if (this.language === 'zh_cn') {
      this.$confirm('确定要删除吗？', {
        confirmButtonText: '是的 ',
        cancelButtonText: '取消',
        type: 'warning',
        callback: (action) => {
          const data: any = {
            id: id,
          }
          if (action === 'confirm') {
            delGcashAccount(data).then(() => {
              this.$message({
                type: 'success',
                message: 'Delete successful!',
              })
              this.hadleGetFilesListApi()
            })
          }
        },
      })
    }
    if (this.language === 'zh_tw') {
      this.$confirm('确定要删除吗？', {
        confirmButtonText: '是的 ',
        cancelButtonText: '取消',
        type: 'warning',
        callback: (action) => {
          const data: any = {
            id: id,
          }
          if (action === 'confirm') {
            delGcashAccount(data).then(() => {
              this.$message({
                type: 'success',
                message: 'Delete successful!',
              })
              this.hadleGetFilesListApi()
            })
          }
        },
      })
    }
  }

  // 分组列表
  private allList: any[] = []
  private async getAllList() {
    try {
      let params: any = {
        page_size: 100,
        page: 1,
      }
      await getAllGcash(params).then((res: any) => {
        this.allList = res.results
      })
    } catch (error) {
      this.allList = []
    }
  }

  private tickList: any = []
  private activeList: any = []
  private batchLogin: any = []
  // private handleSelectionChange(list) {
  //   list.length > 1 ? (this.flag = false) : (this.flag = true)
  //   this.selectList = list
  //   this.activeList = list.filter(item => {
  //     return item.onlie_status === 1
  //   })
  //   this.batchLogin = list.filter(item => {
  //     return item.onlie_status === 0
  //   })
  // }

  private async init() {
    this.orderStatusList = AppModule.GetOrderStatusList()
    await this.hadleGetFilesListApi()
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  // 邀请登录
  private inviteLoading: boolean = false
  private async inviteLogin() {
    try {
      this.inviteLoading = true
      this.flag = true
      let data: any = {
        action: 'invite_login_gcash',
      }
      await setInviteLogin(data).then((res: any) => {
        // window.open(res.url)
        this.copy(res.url)
        this.flagStr()
        this.inviteLoading = false
      })
    } catch (error) {
      this.inviteLoading = false
      this.flagStr()
    }
  }

  // 一键登录
  private loading: boolean = false
  private async openLogin(row: any) {
    try {
      this.loading = true
      let data: any = {
        action: 'login_gcash',
        data: {
          msisdn: row.account_no,
        },
      }
      await setInviteLogin(data).then((res: any) => {
        // window.open(res.url)
        // this.copy(res.url)
        if (res.result === 'true') {
          this.$message.success(res.message)
        } else if (res.code === 1003 && row.sms_id === null) {
          this.loginOtopVisble = true
          this.payBankForm.msisdn = row.account_no
        } else {
          this.$message.error(res.message)
        }
        this.loading = false
        this.hadleGetFilesListApi()
      })
    } catch (error) {
      this.loading = false
    }
  }

  private loginOtopVisble: boolean = false
  private payBankForm: any = {
    msisdn: '',
    otp: '',
  }
  private back() {
    this.loginOtopVisble = false
    this.payBankForm = {
      msisdn: '',
      otp: '',
    }
  }
  private async payBank() {
    ;(this.$refs.payBankForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          let data: any = {
            action: 'mpin_otp',
            data: {
              ...this.payBankForm,
            },
          }
          await setInviteLogin(data).then((res: any) => {
            if (res.result === 'true') {
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
            this.loading = false
            this.back()
            this.hadleGetFilesListApi()
          })
        } catch (error) {
          this.loading = false
        }
      }
    })
  }

  // 批量转账
  private batchLoading: boolean = false
  private timer: any = ''
  private async inviteBatch() {
    try {
      let data: any = {
        action: 'batch_transfer_status',
      }
      this.batchLoading = true
      await setInviteLogin(data).then((res: any) => {
        // this.batchLoading = fals
        if (res.message === '1') {
          this.timer = setTimeout(() => {
            this.inviteBatch()
          }, 3 * 1000)
        } else {
          this.batchLoading = false
          clearInterval(this.timer)
          this.timer = null
        }
      })
    } catch (error) {}
  }

  private copy(val) {
    navigator.clipboard.writeText(val).then(() => {
      this.$message.success('Copy successfully')
    })
  }

  destroyed() {
    // 离开页面是销毁
    clearInterval(this.timer)
    this.timer = null
  }

  mounted() {
    this.init()
    // this.getAllList()
    this.inviteBatch()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.gcash`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
